import { Component, input } from '@angular/core';

@Component({
  selector: 'onyx-loading-bar',
  imports: [],
  templateUrl: './onyx-loading-bar.component.html',
  styleUrl: './onyx-loading-bar.component.scss',
  host: {
    '[class.immediate]': `immediate()`,
    '[class.visible]': `visible()`,
  },
})
export class OnyxLoadingBarComponent {
  public readonly visible = input.required<boolean>();
  public readonly immediate = input(false);
}
